var map = {
	"./banner-01.jpg": "Q3Je",
	"./banner-chenlieshi.jpg": "/H5m",
	"./banner-jinian.jpg": "WiY+",
	"./banner-rongyu.jpg": "fY3P",
	"./banner-shengping.jpg": "4CTj",
	"./banner-wencui.jpg": "D+Iq",
	"./banner-xinwen.jpg": "28In",
	"./banner-yingyin.jpg": "ruC2",
	"./bg-boyata.png": "0gMy",
	"./bg-chronology.jpg": "F1zG",
	"./bg-pu.png": "9yIw",
	"./bg-reward-cover.png": "SUNw",
	"./bg-ziti.png": "uky+",
	"./book01.png": "MBDT",
	"./default-cover.jpg": "SEsj",
	"./home-bg-rongyu.png": "ZnqZ",
	"./home-bg-room.jpg": "fABc",
	"./home-bg-wencui.png": "sScO",
	"./home-honor-01.png": "Llpt",
	"./home-honor-02.png": "aPVN",
	"./home-honor-03.png": "jvfy",
	"./honor01.jpg": "0y6z",
	"./honor02.jpg": "WFMO",
	"./honor03.jpg": "iysJ",
	"./honor04.jpg": "MAwy",
	"./honor05.jpg": "MVe6",
	"./honor06.jpg": "6MMG",
	"./honor07.jpg": "Kppy",
	"./honor08.jpg": "lPrO",
	"./honor09.jpg": "2V1K",
	"./honor10.jpg": "sM7s",
	"./honor11.jpg": "7dmW",
	"./ic-arrow-blue.png": "3PhY",
	"./ic-arrow-white.png": "b+qJ",
	"./ic-ertificate.png": "kywS",
	"./ic-hand-paper.png": "wzxp",
	"./ic-news-paper.png": "sdZ+",
	"./ic-patent.png": "TtYZ",
	"./ic-play.png": "6ERU",
	"./ic-reward-24.png": "+65H",
	"./ic-rewards.png": "z8Ln",
	"./ic-right-arrow.png": "+AtZ",
	"./img01.png": "Zk4q",
	"./index-bg-shengping.jpg": "fK5y",
	"./index-m-01.png": "8i7o",
	"./index-sp-1.jpg": "6iOH",
	"./index-sp-2.jpg": "pmai",
	"./index-sp-3.jpg": "Y1MQ",
	"./logo-3.png": "+hM+",
	"./logo.png": "dLd/",
	"./maisui-l.png": "mEvG",
	"./maisui-r.png": "KUA6",
	"./map.png": "EoJS",
	"./reward01.png": "91N1",
	"./showroom01.jpg": "82Hf",
	"./showroom02.jpg": "5r3d",
	"./showroom03.jpg": "uAby",
	"./star-line.png": "XAmd",
	"./timeline-bg1.jpg": "wS9N",
	"./timeline-bg2.jpg": "REHQ",
	"./timeline-bg3.jpg": "aeiI",
	"./u15.jpg": "dcbq",
	"./wheat-left.png": "qKOg",
	"./wheat-right.png": "5ZNp",
	"./wict-weixin.png": "z4dx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "czpq";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*$
// module id = czpq
// module chunks = 0